import React from 'react';
import { CHARACTER_IDS } from '../types/magical';
import { getCharacterColors } from '../types/characterColors';

const MagicalCounter = ({ 
  currentLap, 
  handleSuikaCount, 
  handleCzCount, 
  handleEyeCatch, 
  isSubtractionMode, 
  setIsSubtractionMode 
}) => {
  return (
    <div>
      {/* カウンター */}
      <div className="bg-white rounded-lg shadow-md p-4 mb-4">
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-lg font-bold">カウンター</h2>
          <div className="flex items-center gap-2 text-xs">
            <span className={`${isSubtractionMode ? 'text-gray-400' : 'text-green-600 font-semibold'}`}>+</span>
            <button
              onClick={() => setIsSubtractionMode(!isSubtractionMode)}
              className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${isSubtractionMode ? 'bg-red-500' : 'bg-green-500'}`}
            >
              <span className={`inline-block h-3 w-3 transform rounded-full bg-white transition ${isSubtractionMode ? 'translate-x-5' : 'translate-x-1'}`} />
            </button>
            <span className={`${isSubtractionMode ? 'text-red-600 font-semibold' : 'text-gray-400'}`}>-</span>
          </div>
        </div>
      
      {/* スイカ・CZ */}
      <div className="grid grid-cols-2 gap-3 mb-4">
        <div className="flex items-center justify-between p-3 bg-gray-50 rounded">
          <span className="font-medium text-sm">スイカ</span>
          <div className="flex items-center gap-2">
            <span className="w-8 text-center font-bold text-sm">{currentLap.suikaCount}</span>
            <button 
              onClick={handleSuikaCount}
              className={`w-12 h-12 sm:w-10 sm:h-10 ${isSubtractionMode ? 'bg-red-500 hover:bg-red-600' : 'bg-blue-500 hover:bg-blue-600'} text-white rounded font-bold text-lg sm:text-sm`}
            >
              {isSubtractionMode ? '-' : '+'}
            </button>
          </div>
        </div>
        
        <div className="flex items-center justify-between p-3 bg-gray-50 rounded">
          <span className="font-medium text-sm">CZ</span>
          <div className="flex items-center gap-2">
            <span className="w-8 text-center font-bold text-sm">{currentLap.czCount}</span>
            <button 
              onClick={handleCzCount}
              className={`w-12 h-12 sm:w-10 sm:h-10 ${isSubtractionMode ? 'bg-red-500 hover:bg-red-600' : 'bg-blue-500 hover:bg-blue-600'} text-white rounded font-bold text-lg sm:text-sm`}
            >
              {isSubtractionMode ? '-' : '+'}
            </button>
          </div>
        </div>
      </div>

      {/* アイキャッチ */}
      <h3 className="text-base font-semibold mb-2">アイキャッチ</h3>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        {CHARACTER_IDS.map(charId => {
          const colors = getCharacterColors(charId);
          return (
            <div key={charId} className={`${colors.background} ${colors.border} border rounded p-2 ${isSubtractionMode ? 'ring-1 ring-red-300' : ''}`}>
              <h4 className={`font-medium mb-1 text-center text-xs ${colors.text.replace('text-white', 'text-gray-800')}`}>{colors.name}</h4>
              
              <div className="flex justify-center gap-1">
                {/* Strong (濃い色) */}
                <div className="flex flex-col items-center gap-1">
                  <span className="text-xs font-bold">{currentLap.eyeCatches[charId].strong}</span>
                  <button 
                    onClick={() => handleEyeCatch(charId, 'strong')}
                    className={`w-12 h-10 sm:w-8 sm:h-7 ${colors.primary} ${colors.hover} ${colors.text} rounded text-base sm:text-xs font-bold`}
                  >
                    {isSubtractionMode ? '-' : '+'}
                  </button>
                </div>
                
                {/* Weak (薄い色) */}
                <div className="flex flex-col items-center gap-1">
                  <span className="text-xs font-bold">{currentLap.eyeCatches[charId].weak}</span>
                  <button 
                    onClick={() => handleEyeCatch(charId, 'weak')}
                    className={`w-12 h-10 sm:w-8 sm:h-7 ${colors.secondary} ${colors.secondaryHover} text-gray-800 rounded text-base sm:text-xs font-bold`}
                  >
                    {isSubtractionMode ? '-' : '+'}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      </div>
      
      {/* 現ラップ簡潔表示 */}
      <div className="bg-blue-50 rounded border border-blue-200 p-3 mt-4">
        <h3 className="text-sm font-semibold mb-2 text-blue-800">現ラップ</h3>
        <div className="grid grid-cols-5 gap-2 text-center text-xs">
          <div>
            <div className="text-gray-600">スイカ</div>
            <div className="font-bold text-blue-700">{currentLap.suikaCount}</div>
          </div>
          <div>
            <div className="text-gray-600">CZ</div>
            <div className="font-bold text-green-700">{currentLap.czCount}</div>
          </div>
          <div>
            <div className="text-gray-600">アイキャッチ</div>
            <div className="font-bold text-orange-700">
              {CHARACTER_IDS.reduce((sum, charId) => 
                sum + currentLap.eyeCatches[charId].strong + currentLap.eyeCatches[charId].weak, 0)}
            </div>
          </div>
          <div>
            <div className="text-gray-600">強確率</div>
            <div className="font-bold text-red-700">
              {(() => {
                const totalEyeCatch = CHARACTER_IDS.reduce((sum, charId) => 
                  sum + currentLap.eyeCatches[charId].strong + currentLap.eyeCatches[charId].weak, 0);
                const totalStrong = CHARACTER_IDS.reduce((sum, charId) => 
                  sum + currentLap.eyeCatches[charId].strong, 0);
                return totalEyeCatch > 0 ? ((totalStrong / totalEyeCatch) * 100).toFixed(1) : '0.0';
              })()}%
            </div>
          </div>
          <div>
            <div className="text-gray-600">CZ率</div>
            <div className="font-bold text-purple-700">
              {currentLap.suikaCount > 0 ? 
                ((currentLap.czCount / currentLap.suikaCount) * 100).toFixed(1) : '0.0'}%
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MagicalCounter;